import { api } from './client'

/**
 * Baixa e DESCOMPRIME uma gravação de sessão.
 *
 * A rota devolve `application/gzip` — o objeto no S3 é `.raw.gz`. Ler os bytes
 * crus e jogar no terminal mostraria lixo binário; e procurar texto neles falha
 * SEMPRE, erro que eu mesmo cometi num teste de ponta a ponta em 01/09/2026
 * antes de perceber que o conteúdo estava comprimido.
 *
 * `DecompressionStream` é nativo nos navegadores que a plataforma suporta e
 * evita carregar uma biblioteca só para isso.
 */
export async function baixarGravacao(
  tenantId: number,
  gravacaoId: number,
): Promise<Uint8Array> {
  const r = await api.get<ArrayBuffer>(
    `/v1/tenants/${tenantId}/ssm/recordings/${gravacaoId}`,
    { responseType: 'arraybuffer' },
  )
  return descomprimir(new Uint8Array(r.data))
}

/** Separada para poder ser testada sem rede. */
export async function descomprimir(bytes: Uint8Array): Promise<Uint8Array> {
  // Gzip começa com 0x1f 0x8b. Sem esta checagem, um corpo já descomprimido
  // (ou uma mensagem de erro em texto) explodiria no stream em vez de aparecer
  // na tela — e o erro do stream não diz nada a quem está lendo.
  if (bytes.length < 2 || bytes[0] !== 0x1f || bytes[1] !== 0x8b) {
    return bytes
  }
  // Alimenta o `DecompressionStream` direto, sem passar por `Blob.stream()`.
  // Nao e preferencia de estilo: o jsdom nao implementa `Blob.stream`, entao a
  // versao com Blob so podia ser testada mockando justamente a descompressao —
  // o teste passaria sem provar nada. Este caminho roda igual no navegador e
  // no teste.
  const ds = new DecompressionStream('gzip')
  const escritor = ds.writable.getWriter()
  // O cast existe porque o TS 5.7 nao aceita `Uint8Array<ArrayBufferLike>`
  // como `BufferSource`. Cheguei a "resolver" passando `bytes.slice().buffer`,
  // que satisfaz o tipo e QUEBRA em execucao — os dois testes de descompressao
  // passaram a estourar o tempo. Mudar comportamento para calar verificador de
  // tipo e trocar um erro visivel por um invisivel.
  void escritor.write(bytes as unknown as BufferSource)
  void escritor.close()
  const buffer = await new Response(ds.readable).arrayBuffer()
  return new Uint8Array(buffer)
}
